import SecuritySettingPage from "./PasswordManagement";

export default SecuritySettingPage;
